import {IPinService, IPinData} from "../services/PinApi";
import {SoilInformation} from "./soil-information";
import {Coordinate} from "ol/coordinate";
import {IPortalServices} from "./portal-services";

export module SoilQuery {
    export class SoilPointQueryService implements IPointQueryService<SoilInformation>, IPointQueryServiceFactory<SoilInformation> {
        // request example url
        // https://smap.landcareresearch.co.nz/services/point_query/json?_dc=1481575287484&layers=smap_soil_drainage&longitude=5794821.2118646&latitude=1884768.4362035&epsg=2193
        points: IPinData[];

        pointQueryFromPin(pin : IPinData) : ng.IPromise<SoilInformation> {
            if (pin.data) {
                // Don't redo a query we don't have to.
                let def = this.$q.defer();
                def.resolve(pin.data);
                return <any> def.promise;
            } else {
                let promise = this.pointQuery([pin.x, pin.y]);
                promise.then((result) => {
                    pin.data = result;
                }, () => { pin.data = null; });
                return promise;
            }

        }
        pointQuery(coord: Coordinate): ng.IPromise<SoilInformation> {
            let $req = this.$http.get<{}>('/services/point_query/json', {
                params : {
                    layers: 'smap_soil_drainage',
                    longitude: coord[1],
                    latitude: coord[0],
                    epsg: '2193'
                },
                cache: true
            });

            return $req.then(resp => {
                let data = <IServiceResponse<IPointQueryData>> resp.data;
                // generate a pseudo-unique id;
                let id = "pin-" + Date.now();
                return new SoilInformation(coord, data.response, id);
            });
        }

        public static $inject = ['$http', '$q', '$rootScope', 'pinService', 'portalServices'];
        constructor(protected $http : ng.IHttpService,
                    protected $q : ng.IQService,
                    protected $rootScope : ng.IRootScopeService,
                    protected pinService : IPinService,
                    protected portalServices: IPortalServices) {
            this.points = [];
        }

        public static factory() {
            return SoilPointQueryService
            // const pointQueryService = ($http: ng.IHttpService, $q : ng.IQService, $rootScope : ng.IRootScopeService, pinService : IPinService) => new SoilPointQueryService($http, $q, $rootScope, pinService);
            // pointQueryService.$inject = ['$http', '$q', '$rootScope', 'pinService', 'portalServices'];
            // return pointQueryService;
        }
    }
    export interface IPointQueryService<T> {
        pointQuery(coord : Coordinate) : ng.IPromise<T>
        pointQueryFromPin(pin : IPinData) : ng.IPromise<T>
    }

    export interface IPointQueryServiceFactory<T> { }



    export interface IServiceResponse<T> {
        response : T
    }

    export interface ILayerPointQueryColumn {
        name: string,
        value?: string|number
    }

    export interface ILayerPointQueryRow {
        columns: ILayerPointQueryColumn[],
        number: number
    }

    export interface ILayerPointQuery {
        name: string,
        raster: boolean,
        rows: ILayerPointQueryRow[]
    }

    export interface IPointQueryData {
        featureType : string;
        layers: ILayerPointQuery[];
        pointHeight : number;
		poiType: string;
    }

}
